// extracted by mini-css-extract-plugin
export var avatarContainer = "_63-1";
export var largeAvatarContainer = "_63-2";
export var smallAvatarContainer = "_63-0";